const u = navigator.userAgent;
export const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; 
export const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
export const isBohaiApp = u.indexOf('NebulaSDK') > -1;
export const isWechat = (u.toLowerCase().match(/MicroMessenger/i)) === 'micromessenger';
/**
 * 判断当前页面是否运行在 微信小程序 web-view 中
 * @returns {boolean} true=小程序内，false=普通浏览器/微信内置浏览器
 */
export function isWechatMiniProgramWebView() {
  // 获取用户代理字符串并转为小写（兼容大小写）
  const userAgent = navigator.userAgent.toLowerCase();
  // 微信小程序webview专属标识：miniProgram（小写为miniprogram）
  return /miniprogram/.test(userAgent);
}